module.exports = __webpack_public_path__ + "img/austria-diabetes-mellitus-male.1380c9b3.png";